// Replaces js/src/events.js. Native DOM events, async/await, no jQuery.

import * as errors from './errors.js';
import { validateQuery } from './validator.js';
import { getList } from './api.js';
import { buildList } from './template.js';

/**
 * Bind submit handlers to the form and the locate button.
 * The original code bound both because $.on('submit') and $.on('click')
 * fired in different orders across browsers; preventDefault on either is
 * sufficient with modern HTML5 form semantics.
 */
export function bindSubmit(apiUrl, apiKey) {
  const form = document.querySelector('.locations-search form');
  if (!form) return;

  form.addEventListener('submit', (e) => {
    e.preventDefault();
    e.stopPropagation();
    handleSubmit(apiUrl, apiKey);
  });
}

async function handleSubmit(apiUrl, apiKey) {
  errors.hideAll();

  const listings = document.querySelector('.locations-listings');
  if (listings) listings.innerHTML = '';

  const zipcode = (document.getElementById('LocationQuery') || {}).value || '';

  if (!validateQuery(zipcode)) {
    errors.show('validation');
    return;
  }

  try {
    const data = await getList(apiUrl, apiKey, zipcode);
    if (!Array.isArray(data) || data.length === 0) {
      errors.show('noResults');
    } else {
      buildList(data);
    }
  } catch (err) {
    if (window.console && console.error) console.error(err);
    errors.show('system');
  }
}
